<!--建筑能效首页-->
<template>
	<div class="beeHomeBody">
		<homeLeft></homeLeft>
		<homeRigth v-if="childData" :areausePower="areausePower"></homeRigth>
	</div>
</template>
<script>
	import homeLeft from '@/page/system/EnergyEfficiencySystem/beeHomeModule/homeLeft.vue'
	import homeRigth from '@/page/system/EnergyEfficiencySystem/beeHomeModule/homeRigth.vue'
	export default {
		components: {
			homeLeft,
			homeRigth,
		},
		props: {},
		data() {
			return {
				areausePower: {
					electricity: [],
					water: [],
					gas: []
				},
				childData: false,
			}
		},
		created() {
			this.initData()
		},
		mounted() {
			//this.$store.cacheStore.state.load=true
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
		},
		watch: {
			nowUnit(nv, ov) {
				this.initData()
			}
		},
		methods: {
			initData() {
				if(isempty(this.nowUnit.id)) {
					return
				}
				this.$api.areausePower.getFindAreausePiwerList(this.nowUnit.id, respon => {
					if(!isempty(respon)) {
						let electricity = []
						let water = []
						let gas = []
						respon.forEach(item => {
							switch(item.appType) {
								case 36:
									electricity.push(item)
									break;
								case 237:
									water.push(item)
									break;
								case 361:
									gas.push(item)
									break;
							}
							this.areausePower.electricity = electricity
							this.areausePower.water = water
							this.areausePower.gas = gas
							this.childData = true
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.beeHomeBody {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #022189;
		color: white;
	}
</style>